<template>
  <div id="play">
    <nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
      <router-link to="/" class="navbar-brand">
        <img src="src/assets/logo.png" class="d-inline-block align-middle" alt="" height="30" />
        <span class="h1 navbar-brand mb-0">Lernin Games</span>
      </router-link>
    </nav>

    <div class="container">
      <h1>{{ title }}</h1>

      <div class="gameloader"></div>

      <h2>More Lernin games:</h2>
      <list-games/>

    </div>
  </div>
</template>


<script>
const iframeClass = 'gameloader--iframe',
  gameLoaderClass = 'gameloader';

import store from '../store';
import ListGames from './ListGames.vue';
import { games } from '../games';

export default {
  name: 'play',
  watch: {
    '$route.params.game_id': function (id) {
      this._loadGame();
    }
  },
  components: {
    'list-games': ListGames
  },
  computed: {
    title() {
      return this._getGameData().title;
    }
  },
  data () {
    return { }
  },
  methods: {
    _send(id, payload) {
      const iframe = document.querySelector(`.${iframeClass}`);
      iframe.contentWindow.postMessage({id, payload}, document.location.origin);
    },
    _loadGame() {
      return new Promise((resolve, reject) => {
        try {
          const iframe = document.createElement('iframe');
          iframe.onload = event => {
            resolve(event.target);
          };
          iframe.onerror = event => {
            reject(event);
          };
          iframe.className = iframeClass;
          iframe.src = 'games/' + this.$route.params.game_id + '/index.html';
          iframe.style.width = "667px";
          iframe.style.height = "375px";
          document.querySelector(`.${gameLoaderClass}`).innerHTML = '';
          document.querySelector(`.${gameLoaderClass}`).appendChild(iframe);
        } catch (error) {
          reject(error);
        }
      });
    },
    _onMessage(event) {
      const id = event.data.id;
      const payload = event.data.payload;
      switch (id) {
      case 'state:get':
        this._send(
          'state:get',
          {}
        );
        break;
      case 'state:set':
        break;
      case 'init':
        const init = {
          'assetsPath': '../../assets/',
          'locale': 'en_US'
        };
        this._send('init', init);
        break;
      case 'track':
        break;
      case 'handshake':
          this._send('handshake');
          break;
      }
    },
    _bindPostMessage() {
      return new Promise((resolve, reject) => {
        try {
          window.addEventListener('message', this._onMessage);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    _getGameData() {
      for (let i = 0; i < games.length; i++) {
        if (games[i].name === this.$route.params.game_id) {
          return games[i];
        }
      }
    }
  },
  mounted: function() {
    console.log('mounted');
    this._loadGame().then( this._bindPostMessage );
  },
  beforeDestroy() {
    removeEventListener('message', this._onMessage);
  },
  created: function() {
    console.log('Play component created');
  }
}

</script>

<style scope>
.gameloader--iframe {
  margin: 10px 0px;
  border: 1px solid #c6c6c6;
  background-color: #a6a6a6;
  width: 100vw;
  height: 100vh;
}
</style>

<style lang="sass">

  .icon-home:before
    content: '\e800'
  .home-button
    position: absolute
    overflow: hidden
    left: 1em
    top: 0.2em
    font-size: 1.5em
    background: Transparent no-repeat
    border: none
    outline: none
    cursor: pointer
    color: white

  .home-button:focus
    outline: 0

</style>



// WEBPACK FOOTER //
// Play.vue?7998e57e